/*eslint-disable*/
import React from 'react'
import { withTranslation } from 'react-i18next'
// nodejs library to set properties for components

import {
  AppBar,
  Box,
  Divider,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
  Link,
  SvgIcon
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import routes from '../../routes'
import useStyles from './styles'
import BrandLogo from './BrandLogo'
import { restaurantSidebarIcons } from './sidebarIcons'
import { useLocation } from 'react-router-dom'

const drawerWidth = 260

const SidebarIcon = ({ route, isActive }) => {
  const color = isActive ? 'common.white' : '#1F2937'
  const Icon = restaurantSidebarIcons[route.name]
  return Icon ? (
    <Icon sx={{ fontSize: 20, color }} />
  ) : (
    <SvgIcon
      component={route.icon}
      fontSize="small"
      sx={{ color, '& path': { fill: 'currentColor' } }}
    />
  )
}
function Sidebar(props) {
  const location = useLocation()
  const classes = useStyles()
  const restaurantId = localStorage.getItem('restaurantId')
  const restaurantImage = localStorage.getItem('restaurantImage')
  const restaurantName = localStorage.getItem('restaurantName')
  const [mobileOpen, setMobileOpen] = React.useState(false)
  const { window, t } = props
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }
  const container =
    window !== undefined ? () => window().document.body : undefined

  const createLinks = (
    <Box className={classes.sidebarBox}>
      <Toolbar className={[classes.rowDisplay, classes.logo]}>
        <BrandLogo />
      </Toolbar>
      <Divider className={classes.sidebarDivider} />
      {restaurantName && restaurantImage ? (
        <Box className={[classes.rowDisplay, classes.restContainer]}>
          <img
            src={restaurantImage}
            className={classes.restImage}
            alt=""
            width="28px"
            height="28px"
          />
          <Typography variant="h2" className={[classes.restText]}>
            {restaurantName}
          </Typography>
        </Box>
      ) : null}

      <Box className={classes.sidebarList}>
        {routes.map((prop, key) => {
          const isActive = location.pathname === `${prop.layout}${prop.path}`
          if (
            JSON.parse(localStorage.getItem('user-borku')).userType === 'ADMIN'
          ) {
            return prop.appearInSidebar && !prop.admin ? (
              <React.Fragment key={`${prop.layout}${prop.path}-${key}`}>
                {key === 15 ? (
                  <Typography className={classes.headingText} variant="h3">
                    {t('RESTAURANT')}
                  </Typography>
                ) : null}
                {key === 20 ? (
                  <Typography className={classes.headingText} variant="h3">
                    {t('MANAGEMENT')}
                  </Typography>
                ) : null}
                <Link
                  className={[
                    classes.rowDisplay,
                    classes.sidebarLink,
                    isActive && classes.active
                  ]}
                  href={
                    '#' + prop.layout + prop.path.replace(':id', restaurantId)
                  }
                  underline="none">
                  <SidebarIcon route={prop} isActive={isActive} />
                  <Typography
                    variant="h6"
                    className={[
                      classes.linkText,
                      isActive ? classes.whiteText : classes.blackText
                    ]}>
                    {t(prop.name)}
                  </Typography>
                </Link>
              </React.Fragment>
            ) : null
          } else {
            return prop.appearInSidebar &&
              !prop.admin &&
              prop.name != t('BackToAdmin') ? (
              <React.Fragment key={`${prop.layout}${prop.path}-${key}`}>
                <Link
                  className={[
                    classes.rowDisplay,
                    classes.sidebarLink,
                    isActive && classes.active
                  ]}
                  href={
                    '#' + prop.layout + prop.path.replace(':id', restaurantId)
                  }
                  underline="none">
                  <SidebarIcon route={prop} isActive={isActive} />
                  <Typography
                    variant="h6"
                    className={[
                      classes.linkText,
                      isActive ? classes.whiteText : classes.blackText
                    ]}>
                    {t(prop.name)}
                  </Typography>
                </Link>
              </React.Fragment>
            ) : null
          }
        })}
      </Box>
    </Box>
  )

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          display: { sm: 'none' },
          bgcolor: 'common.white',
          color: 'text.primary',
          boxShadow: 'none',
          borderBottom: '1px solid',
          borderColor: 'divider'
        }}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}>
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="main navigation">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: '78%',
              backgroundColor: 'common.white'
            }
          }}>
          {createLinks}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              backgroundColor: 'common.white',
              borderRight: '1px solid',
              borderColor: 'divider'
            }
          }}
          open>
          {createLinks}
        </Drawer>
      </Box>
    </>
  )
}

export default withTranslation()(Sidebar)
